export default {
  edit: "menu:edit",
  create: "menu:create",
  delete: "menu:delete",
  view: "menu:view",
};
